export enum CookieKeys {
  UserData = "userData",
  Email = "email",
  IsEmailVerified = "is_email_verified",
  Type = "type",
  AccessToken = "accessToken",
  RefreshToken = "refreshToken",
  JobSlug = "job_slug",
  EmailCollect = "email_collect",
  EmailCollectClose = "email_collect_close",
  Redirect = "redirect",
  WorkFairModal = "workfair_modal",
  UUID = "uuid",
  SpeakerLogin = "speaker_login",
  InviteCode = "invite_code",
  UserCountry = "user_country",
  UserLocation = "user_location",
  CookieBannerAccepted = "cookie_banner_accepted",
  InlineEmailCollectSubmitted = "inline_email_collect_submitted",
  NonMemberUUID = "non_member_uuid",
}
